module.exports = __webpack_public_path__ + "img/bg02.075e05b6.jpg";